/*
 * @Author: v_smwang
 * @Date: 2020-08-01 11:18:33
 * @LastEditors: v_smwang
 * @LastEditTime: 2020-08-14 10:34:11
 * @FilePath: \src\api\personnelPortraitOverview.js
 * @Description: 描述
 * @Module: 模块路径
 */
import { axios } from '@/utils/request';

const api = {
// 筛选
  productionLine: 'service/info/overview/production_line', // 获取筛选项的产线列表
  outsourcer: 'service/info/overview/outsourcer', // 获取筛选项的供应商列表
  tasktype: 'service/info/overview/task_type', // 获取筛选项的任务类型列表
  tasklabel: 'service/info/overview/task_label', // 获取筛选项的任务标签列表
  // 人员综合
  avgScore: 'service/overview/avg_score', // 整体平均分数雷达图
  operatorScoreStep: 'service/overview/operator_score_step', // 人员综合分数阶梯分布图
  zongRank: 'service/overview/operator_score_rank_query', // 人员综合评价表格
  synthesizeScoreStepDistribution: 'service/overview/synthesize_score_step_distribution', // 产线、供应商综合维度评价_产线和供应商一个接口，参数不一样
  zongRankExport: 'service/overview/operator_score_rank_export', // 人员综合排名导出

  // 人员单项
  singleOperatorScoreStep: 'service/overview/single_operator_score_step', // 人员单项分数阶梯分布
  singRank: 'service/overview/single_operator_score_rank_query', // 人员单项评价表格
  singletonSynthesizeScoreStepDistribution: 'service/overview/singleton/synthesize_score_step_distribution', // 人员单项评价的综合分数阶梯分布_产线和供应商一个接口，参数不一样
  singRankExport: 'service/overview/single_operator_score_rank_export', // 人员单项排名导出

  // 提质提效
  qualityEfficiencyScatter: 'service/overview/quality_efficiency/scatter', // 散点图
  qualityEfficiencyScatterExport: 'service/overview/quality_efficiency/scatter_export', // 散点图导出
  qualityEfficiencyComprehensive: 'service/overview/quality_efficiency/comprehensive', // 质量效率总和评价分布柱状图
  qualityEfficiencyComprehensiveExport: 'service/overview/quality_efficiency/comprehensive_export', // 质量效率总和评价分布柱状图导出
  qualityEfficiencyEfficiency: 'service/overview/quality_efficiency/efficiency', // 分层效率分布
  qualityEfficiencyEfficiencyExport: 'service/overview/quality_efficiency/efficiency_export', // 分层效率分布导出
  qualityEfficiencyQuality: 'service/overview/quality_efficiency/quality', // 分层质量分布
  qualityEfficiencyQualityExport: 'service/overview/quality_efficiency/quality_export', // 分层质量分布

  // 综合概览表格
  gailanTable: 'service/overview/overview_query', // 综合概览表格
  gailanExport: 'service/overview/overview_export', // 概览表格导出

  // 得到产线
  getProductLine: 'service/info/operator_pl',
  test: '',

  // 综合得分时间趋势图
  avgScoreTrend: 'service/overview/avg_score_trend',
  singletonZbTrend: 'service/overview/singleton/zb_trend',
};

/**
 * 综合得分时间趋势图
 * @param {*} params
 */
export function avgScoreTrend(params) {
  return axios({
    url: api.avgScoreTrend,
    method: 'get',
    params,
  });
}

/**
 * 评价维度时间趋势
 * @param {*} params
 */
export function singletonZbTrend(params) {
  return axios({
    url: api.singletonZbTrend,
    method: 'get',
    params,
  });
}

/**
 *人员画像概览——筛选条件——产线
 * @param {*} params
 */
export function getProductionLine(params) {
  return axios({
    url: api.productionLine,
    method: 'get',
    params,
  });
}

/**
 *人员画像概览——筛选条件——供应商
 * @param {*} params
 */
export function getOutsourcer(params) {
  return axios({
    url: api.outsourcer,
    method: 'get',
    params,
  });
}

/**
 *人员画像概览——筛选条件——任务类型
 * @param {*} params
 */
export function getTasktype(params) {
  return axios({
    url: api.tasktype,
    method: 'get',
    params,
  });
}
/**
 *人员画像概览——筛选条件——任务类型
 * @param {*} params
 */
export function getTasklabel(params) {
  return axios({
    url: api.tasklabel,
    method: 'get',
    params,
  });
}

/**
 *人员画像概览——图表——人员综合评价——雷达图
 * @param {*} params
 */
export function getAvgScore(params) {
  return axios({
    url: api.avgScore,
    method: 'get',
    params,
  });
}

/**
 *人员画像概览——图表——人员综合评价——人员综合分数阶梯分布柱状图
 * @param {*} params
 */
export function getOperatorScoreStep(params) {
  return axios({
    url: api.operatorScoreStep,
    method: 'get',
    params,
  });
}

/**
 *人员画像概览——图表——人员综合评价——综合排名表
 * @param {*} params
 */
export function getZongRank(params) {
  return axios({
    url: api.zongRank,
    method: 'get',
    params,
  });
}

/**
 *人员画像概览——图表——人员综合评价——综合排名表导出
 * @param {*} params
 */
export function zongRankExport(params) {
  return axios({
    url: api.zongRankExport,
    method: 'get',
    params,
  });
}

/**
 *人员画像概览——图表——产线、供应商综合维度评价——产线、供应商维度综合分数阶梯分布柱状图_产线和供应商一个接口，参数不一样
 * @param {*} params
 */
export function getSynthesizeScoreStepDistribution(params) {
  return axios({
    url: api.synthesizeScoreStepDistribution,
    method: 'get',
    params,
  });
}

/**
 *人员画像概览——图表——人员单项评价柱状图
 * @param {*} params
 */
export function getSingleOperatorScoreStep(params) {
  return axios({
    url: api.singleOperatorScoreStep,
    method: 'get',
    params,
  });
}

/**
 *人员画像概览——图表——人员单项评价表格
 * @param {*} params
 */
export function getSingRank(params) {
  return axios({
    url: api.singRank,
    method: 'get',
    params,
  });
}

/**
 *人员画像概览——图表——人员单项评价表格导出
 * @param {*} params
 */
export function singRankExport(params) {
  return axios({
    url: api.singRankExport,
    method: 'get',
    params,
  });
}

/**
 *人员画像概览——图表——产线、供应商维度单项评价——产线、供应商维度XX达标阶梯分布柱状图_产线和供应商一个接口，参数不一样
 * @param {*} params
 */
export function getSingletonSynthesizeScoreStepDistribution(params) {
  return axios({
    url: api.singletonSynthesizeScoreStepDistribution,
    method: 'get',
    params,
  });
}

/**
 *人员画像概览——图表——综合概览表格
 * @param {*} params
 */
export function getGaiLanTable(params) {
  return axios({
    url: api.gailanTable,
    method: 'get',
    params,
  });
}

/**
 *人员画像概览——图表——综合概览表格导出
 * @param {*} params
 */
export function gaiLanExport(params) {
  return axios({
    url: api.gailanExport,
    method: 'get',
    params,
  });
}

/**
 * 获取散点图
 * @param params
 */
export function getQualityEfficiencyScatter(params) {
  return axios({
    url: api.qualityEfficiencyScatter,
    method: 'get',
    params,
  });
}

/**
 * 获取散点图导出
 * @param params
 */
export function getQualityEfficiencyScatterExport(params) {
  return axios({
    url: api.qualityEfficiencyScatterExport,
    method: 'get',
    params,
  });
}

/**
 * 获取质量效率总和评价分布柱状图
 * @param params
 */
export function getQualityEfficiencyComprehensive(params) {
  return axios({
    url: api.qualityEfficiencyComprehensive,
    method: 'get',
    params,
  });
}

/**
 * 获取质量效率总和评价分布柱状图导出
 * @param params
 */
export function getQualityEfficiencyComprehensiveExport(params) {
  return axios({
    url: api.qualityEfficiencyComprehensiveExport,
    method: 'get',
    params,
  });
}

/**
 * 获取分层效率分布
 * @param params
 */
export function getQualityEfficiencyEfficiency(params) {
  return axios({
    url: api.qualityEfficiencyEfficiency,
    method: 'get',
    params,
  });
}

/**
 * 获取分层效率分布导出
 * @param params
 */
export function getQualityEfficiencyEfficiencyExport(params) {
  return axios({
    url: api.qualityEfficiencyEfficiencyExport,
    method: 'get',
    params,
  });
}

/**
 * 获取分层质量分布
 * @param params
 * @returns {AxiosPromise}
 */
export function getQualityEfficiencyQuality(params) {
  return axios({
    url: api.qualityEfficiencyQuality,
    method: 'get',
    params,
  });
}

/**
 * 获取分层质量分布
 * @param params
 * @returns {AxiosPromise}
 */
export function getQualityEfficiencyQualityExport(params) {
  return axios({
    url: api.qualityEfficiencyQualityExport,
    method: 'get',
    params,
  });
}

/**
 * 根据姓名得到最后一条产线
 * @param params
 * @returns {AxiosPromise}
 */
export function getProductLine(params) {
  return axios({
    url: api.getProductLine,
    method: 'get',
    params,
  });
}
